var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 15.55054a3.5 3.5 0 1 0 1 0v-1.55054a1.50164 1.50164 0 0 1 1.5-1.5h8a2.50263 2.50263 0 0 0 2.5-2.5v-1.55054a3.5 3.5 0 1 0 -1 0v1.55054a1.50164 1.50164 0 0 1 -1.5 1.5h-8a2.47588 2.47588 0 0 0 -1.5.51276v-3.5633a3.5 3.5 0 1 0 -1 0zm10-10.55054a2.5 2.5 0 1 1 2.5 2.5 2.50263 2.50263 0 0 1 -2.5-2.5zm-12 0a2.5 2.5 0 1 1 2.5 2.5 2.50294 2.50294 0 0 1 -2.5-2.5zm2.5 11.5a2.5 2.5 0 1 1 -2.5 2.5 2.50294 2.50294 0 0 1 2.5-2.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/fork.ea32b21a3a6650c9286fb0512da5b304.svg";
export { ForwardRef as ReactComponent };